import { render, staticRenderFns } from "./ForgotPasswordDialogComponent.vue?vue&type=template&id=2633a5a2&scoped=true&"
import script from "./ForgotPasswordDialogComponent.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordDialogComponent.vue?vue&type=style&index=0&id=2633a5a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633a5a2",
  null
  
)

export default component.exports